import { render, staticRenderFns } from "./OneJurnal.vue?vue&type=template&id=338b98e2&scoped=true&"
import script from "./OneJurnal.vue?vue&type=script&lang=js&"
export * from "./OneJurnal.vue?vue&type=script&lang=js&"
import style0 from "./OneJurnal.vue?vue&type=style&index=0&id=338b98e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338b98e2",
  null
  
)

export default component.exports